import { render, staticRenderFns } from "./SponsorEditTabAccount.vue?vue&type=template&id=35543251&scoped=true&"
import script from "./SponsorEditTabAccount.vue?vue&type=script&lang=js&"
export * from "./SponsorEditTabAccount.vue?vue&type=script&lang=js&"
import style0 from "./SponsorEditTabAccount.vue?vue&type=style&index=0&id=35543251&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35543251",
  null
  
)

export default component.exports